import React from 'react';

export const Sort = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2719_2215)">
      <path
        d="M7.99993 3.88661L9.63993 5.52661C9.89993 5.78661 10.3199 5.78661 10.5799 5.52661C10.8399 5.26661 10.8399 4.84661 10.5799 4.58661L8.46659 2.46661C8.20659 2.20661 7.78659 2.20661 7.52659 2.46661L5.41326 4.58661C5.15326 4.84661 5.15326 5.26661 5.41326 5.52661C5.67326 5.78661 6.09326 5.78661 6.35326 5.52661L7.99993 3.88661ZM7.99993 12.1133L6.35993 10.4733C6.09993 10.2133 5.67993 10.2133 5.41993 10.4733C5.15993 10.7333 5.15993 11.1533 5.41993 11.4133L7.53326 13.5333C7.79326 13.7933 8.21326 13.7933 8.47326 13.5333L10.5866 11.4199C10.8466 11.1599 10.8466 10.7399 10.5866 10.4799C10.3266 10.2199 9.90659 10.2199 9.64659 10.4799L7.99993 12.1133Z"
        fill="#101828"
      />
    </g>
    <defs>
      <clipPath id="clip0_2719_2215">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
